import BaseModule from '@core/modules/base-module/base-module';

const listBlock = new BaseModule();
listBlock.name = 'simple-list-block';
listBlock.init();
